import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';
import { useSMLCountryParam } from './useSMLCountryParam';
import { useSMLGenreParam } from './useSMLGenreParam';

interface UseTracksTopOverallProps {
  page: number;
  limit?: number;
  date?: Date;
  artistId?: string;
}

export const useTracksTopOverall = ({ page, limit = 10, date, artistId }: UseTracksTopOverallProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const { countryCode } = useSMLCountryParam();
  const { genre } = useSMLGenreParam();
  const offset = (page - 1) * limit;

  const tracksQuery = useTRPCQuery(
    trpcMusicAPI.tracks.topOverall.queryOptions({
      offset,
      limit,
      date: date ?? undefined,
      artistId: artistId ?? undefined,
      countryCode,
      genre,
      ...shareTokenInput,
    })
  );

  return tracksQuery;
};
